/**
 * i18n Configuration for StudyJoyful Web
 *
 * Uses shared translations from @studyjoyful/shared package
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  resources,
  namespaces,
  defaultNS,
  defaultLanguage,
} from '@studyjoyful/shared';

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLanguage,
  fallbackLng: defaultLanguage,
  ns: [...namespaces],
  defaultNS,
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  react: {
    useSuspense: false, // Disable suspense to avoid hydration issues
  },
});

export default i18n;

